import { useState } from "react";
import { useApi } from "providers/ProvideApi";
import { wrapError } from "../../utils";
import { useAlert } from "advancement-solutions-components/dist/providers";

export const useAddPrompt = () => {
  const { authApi } = useApi();
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const { send } = useAlert();

  const add = async (values) => {
    try {
      setIsUpdating(true);
      setError(null);
      const response = await authApi.post(`/api/prompts`, values);
      setData(response.data);
      send({ message: "Prompt added.", severity: "info" });
    } catch (e) {
      const error = wrapError(e);
      send({
        message: `Prompt was not added: ${error.message}`,
        severity: "error",
      });
      setError(error);
    } finally {
      setIsUpdating(false);
    }
  };

  return [data, add, isUpdating, error];
};

export default useAddPrompt;
